export class CapsStyle {
    public static NONE: string = "none";
    public static ROUND: string = "round";
    public static SQUARE: string = "square";
}
